export default "__VITE_ASSET__GAaQqyvm__"